// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_sortation_management_ui_styles" + "." + "13ea2f28" + ".chunk.css";
};